/*
    axios 请求封装
*/
import axios  from 'axios'

const request = axios.create({
    baseURL: process.env.VUE_APP_BASE_API,
    withCredentials: false,  //跨域请求是否需要凭证
    timeout: 10000,
})
//请求拦截器
request.interceptors.request.use(
    //请求前验证
    (config) => {
        if (sessionStorage.getItem("token")) {
            config.headers = { token: sessionStorage.getItem("token") };
        }

        if(sessionStorage.getItem("appid")) {
            config.headers.appid = sessionStorage.getItem("appid");
        }
        if(sessionStorage.getItem("enterid")) {
            config.headers.enterid = sessionStorage.getItem("enterid");
        }
        if(sessionStorage.getItem("k")) {
            config.headers.k = sessionStorage.getItem("k");
        }
        return config;
    },
    //请求错误处理
    (error) => {
        return Promise.reject(error);
    }
);

//响应拦截器
request.interceptors.response.use(
    response => {
            return response.data
    },
    error => {
        return Promise.reject(error)
})

export default request
